import React from "react";
import Link from "next/link";
import LogoWeiß from "@/assets/footer/Autoeinfachlos_logo_weiss.webp";
import FacebookLogo from "@/assets/svgs/FacebookLogo";
import InstagramLogo from "@/assets/svgs/InstagramLogo";
import playStore from "@/assets/footer/google_play_badge.png";
import appStore from "@/assets/footer/apple_appstore_badge.png";
import { APP_STORE_URL, PLAY_STORE_URL } from "@/config/appLinks";

import "./Footer.css";
import Image from "next/image";
import ButtonAnimated from "../ButtonAnimated/ButtonAnimated";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-column-wrapper">
        <div className="footer-column first">
          <div className="footer-logo-socials">
            {/* Logo: real display size ~160x28 */}
            <Image
              className="Footer-logo"
              src={LogoWeiß}
              alt="Autoeinfachlos - Auto einfach online verkaufen"
              width={160}
              height={28}
              sizes="160px"
              loading="lazy"
            />

            <div className="footer-socials-wrapper">
              <a
                href="https://www.facebook.com/Autoeinfachlos"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social"
                aria-label="Autoeinfachlos auf Facebook (öffnet in neuem Tab)"
              >
                <FacebookLogo
                  alt="facebook"
                  className="footer-socials-icon"
                  width={24}
                  height={24}
                />
              </a>

              <a
                href="https://www.instagram.com/autoeinfachlos"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social"
                aria-label="Autoeinfachlos auf Instagram (öffnet in neuem Tab)"
              >
                <InstagramLogo
                  alt="instagram"
                  className="footer-socials-icon"
                  width={24}
                  height={24}
                />
              </a>
            </div>
          </div>

          <div className="footer-appStores">
            {/* App Store badge: display ~152px wide */}
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-appStore-link"
              aria-label="Autoeinfachlos App im Apple App Store (öffnet in neuem Tab)"
            >
              <Image
                src={appStore}
                className="footer-appStore-icon"
                alt="Autoeinfachlos App – Laden im App Store"
                width={152}
                height={45}
                sizes="152px"
                loading="lazy"
              />
            </a>
            {/* Play Store badge: display ~152px wide */}
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-appStore-link"
              aria-label="Autoeinfachlos App im Google Play Store (öffnet in neuem Tab)"
            >
              <Image
                src={playStore}
                className="footer-appStore-icon"
                alt="Autoeinfachlos App – Jetzt bei Google Play"
                width={152}
                height={45}
                sizes="152px"
                loading="lazy"
              />
            </a>
          </div>
        </div>

        <div className="footer-column second">
          <h3>Über Autoeinfachlos</h3>

          <ul className="footer-list-wrapper">
            <li className="footer-list-item">
              <Link href="/ueber-uns">
                <span>Über uns </span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/so-funktionierts">
                <span>So funktionierts</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <a
                href="https://de.trustpilot.com/review/autoeinfachlos.at"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Erfahrungen</span>
              </a>
            </li>
            <li className="footer-list-item">
              <Link href="/ratgeber">
                <span>Ratgeber</span>
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column third">
          <h3>Service</h3>

          <ul className="footer-list-wrapper">
            <li className="footer-list-item">
              <Link href="/auto-verkaufen">
                <span>Auto Verkaufen</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/auto-bewerten">
                <span>Bewertungstool</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/fahrgestellnummer-pruefen">
                <span>FIN Prüfen tool</span>
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-column fourth">
          <h3>Hilfe & Information</h3>

          <ul className="footer-list-wrapper">
            <li className="footer-list-item">
              <Link href="/faq">
                <span>Häufige Fragen</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/kontaktiere-uns">
                <span>Kontaktiere uns</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="/presse">
                <span>Presse</span>
              </Link>
            </li>
            <li className="footer-list-item">
              <Link href="tel:+43720881186">
                <span>Telefon: +43 720 881186</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-end-wrapper">
        <ButtonAnimated
          text="Autoeinfachlos für Händler"
          fill="#fff"
          width="336px"
          height="58px"
          hideMaxWidth
          borderColor="#61615e"
          hoverBorderColor="#fff"
          backgroundColor="transparent"
          hoverBackgroundColor="#343431"
          color="#fff"
          fontSize="18px"
          chevronHeight="22px"
          className="desktop"
          link="https://pro.autoeinfachlos.at"
        />

        <ButtonAnimated
          text="Autoeinfachlos für Händler"
          fill="#fff"
          width="300px"
          height="48px"
          borderColor="#61615e"
          hoverBorderColor="#fff"
          backgroundColor="transparent"
          hoverBackgroundColor="#343431"
          color="#fff"
          fontSize="16px"
          chevronHeight="22px"
          className="mobile"
          hideMaxWidth
          link="https://pro.autoeinfachlos.at"
        />

        <ul className="footer-end-list">
          <li className="footer-end-list-item transition">
            <Link href="/impressum">Impressum</Link>
          </li>
          <li className="footer-end-list-item transition">
            <Link href="/agb">AGB</Link>
          </li>
          <li className="footer-end-list-item transition">
            <Link href="/datenschutz">Datenschutz</Link>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
